import EnhancedQuiz from "tds/enhancedQuiz";

export { EnhancedQuiz };

customElements.define(
  "tds-enhanced-quiz",
  EnhancedQuiz.CustomElementConstructor
);
